import { useContext } from "react";
import { AppContext } from "../App";
import { getCurrentYear } from "../Helpers";
import logo from "../assets/logo.png";
import { serviceCategories } from "./ServicesContent";

const aboutLinks = [
  { label: "Overview", subItem: "overview" },
  { label: "Team", subItem: "team" },
  { label: "Policies", subItem: "policies" },
];

export default function Footer() {
  const appContext = useContext(AppContext);

  return (
    <footer className="tgm-footer">
      <div className="container">
        <div className="tgm-footer-grid">
          <div className="tgm-footer-brand-block">
            <img src={logo} alt="SMART TGM Limited" />
            <h3>Civil and building works with assured execution.</h3>
            <p>
              SMART TGM Limited supports clients with construction planning,
              project coordination, engineering input, and site delivery.
            </p>
          </div>

          <div>
            <span className="tgm-footer-label">Navigation</span>
            <button type="button" onClick={() => appContext.navTo({ item: "home" })}>
              Home
            </button>
            <button
              type="button"
              onClick={() => appContext.navTo({ item: "projects" })}
            >
              Projects
            </button>
            <button
              type="button"
              onClick={() => appContext.navTo({ item: "services" })}
            >
              Services
            </button>
            <button
              type="button"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Contact
            </button>
          </div>

          <div>
            <span className="tgm-footer-label">About</span>
            {aboutLinks.map((link) => (
              <button
                key={link.subItem}
                type="button"
                onClick={() =>
                  appContext.navTo({
                    item: "about_us",
                    subItem: link.subItem,
                  })
                }
              >
                {link.label}
              </button>
            ))}
          </div>

          <div>
            <span className="tgm-footer-label">Services</span>
            {serviceCategories.slice(0, 5).map((service) => (
              <button
                key={service.slug}
                type="button"
                onClick={() =>
                  appContext.navTo({
                    item: "services",
                    subItem: service.slug,
                  })
                }
              >
                {service.title}
              </button>
            ))}
          </div>

          <div>
            <span className="tgm-footer-label">Contact</span>
            <a href="mailto:Smarttgmtz@gmail.com">Smarttgmtz@gmail.com</a>
            <a href="tel:+255789500326">+255 789 500 326</a>
            <p>Vijana House, Mwananyamala A, Kinondoni, Dar es Salaam.</p>
          </div>
        </div>

        <div className="tgm-footer-bottom">
          <p>&copy; SMART TGM Limited {getCurrentYear()}</p>
          <p>
            Website created by{" "}
            <a className="werenium" href="https://werenium.com" target="_blank" rel="noreferrer">
              Werenium Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
